// Supermove
import {gql} from '@supermove/graphql';
import {MutationError, useForm, useFormMutation} from '@supermove/hooks';

// App
import StageForm from '@shared/modules/Project/forms/StageForm';

const useCreateStageMutation = ({
  stageForm,
  onSuccess,
  onError,
}: {
  stageForm: any;
  onSuccess: () => void;
  onError: (error: MutationError[]) => void;
}) => {
  const form = useForm({
    initialValues: {
      stageForm: StageForm.toForm(stageForm),
    },
  });

  const {submitting, handleSubmit} = useFormMutation({
    form,
    mutation: useCreateStageMutation.mutation,
    variables: {
      stageForm: StageForm.toMutation(form.values.stageForm),
    },
    onSuccess,
    onError,
  });

  return {
    form,
    submitting,
    handleSubmit,
  };
};

// --------------------------------------------------
// GraphQL Mutation Definition
// --------------------------------------------------
useCreateStageMutation.mutation = gql`
  mutation CreateStageMutation($stageForm: StageForm!) {
    response: createStage(stageForm: $stageForm) {
      errors {
        field
        message
      }
      stage {
        id
        name
        projectStatus
        description
        color
        playbookTemplate {
          id
          name
        }
      }
    }
  }
`;

export default useCreateStageMutation;
